import React from "react";

import { Button, Modal } from "react-bootstrap";

function ExternalLinkModal({ showModal, handleContinue, handleClose }) {
  return (
    <div>
      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>You are leaving our site</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>
            You are now leaving our site. Are you sure you want to continue to
            an external site?
          </p>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" onClick={handleContinue}>
            Continue
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
export default ExternalLinkModal;
